import axios from "axios"
import { getRequestConfig } from "./auth"
import { ApiGateway } from "../config/config"

export const sendActivity = async (activity) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.user}/activity`

  try {
    await axios.post(basePath, activity, requestConfig)
  } catch (e) {
    console.error('Error on Activity: ', e.response.data.error)
  }
}